/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProfessionType } from '../models/profession-type';

@Injectable({
  providedIn: 'root',
})
export class RDataService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation compensationApiRdataAggregatesSpecialtiesGet
   */
  static readonly CompensationApiRdataAggregatesSpecialtiesGetPath = '/compensation-api/rdata/aggregates/specialties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiRdataAggregatesSpecialtiesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiRdataAggregatesSpecialtiesGet$Plain$Response(params?: {

    /**
     * The types of professions.
     */
    ProfessionType?: ProfessionType;
    'api-version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, RDataService.CompensationApiRdataAggregatesSpecialtiesGetPath, 'get');
    if (params) {
      rb.query('ProfessionType', params.ProfessionType, {});
      rb.query('api-version', params['api-version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiRdataAggregatesSpecialtiesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiRdataAggregatesSpecialtiesGet$Plain(params?: {

    /**
     * The types of professions.
     */
    ProfessionType?: ProfessionType;
    'api-version'?: string;
  },
  context?: HttpContext

): Observable<Array<string>> {

    return this.compensationApiRdataAggregatesSpecialtiesGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiRdataAggregatesSpecialtiesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiRdataAggregatesSpecialtiesGet$Json$Response(params?: {

    /**
     * The types of professions.
     */
    ProfessionType?: ProfessionType;
    'api-version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, RDataService.CompensationApiRdataAggregatesSpecialtiesGetPath, 'get');
    if (params) {
      rb.query('ProfessionType', params.ProfessionType, {});
      rb.query('api-version', params['api-version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiRdataAggregatesSpecialtiesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiRdataAggregatesSpecialtiesGet$Json(params?: {

    /**
     * The types of professions.
     */
    ProfessionType?: ProfessionType;
    'api-version'?: string;
  },
  context?: HttpContext

): Observable<Array<string>> {

    return this.compensationApiRdataAggregatesSpecialtiesGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
